<template>
  <div class="pre-checkout-sidebar-register">
    <slot name="error"></slot>
    <div class="pre-checkout-sidebar-login-checkouttitle">
      Checkout
    </div>
    <div class="pre-checkout-sidebar-register-title">
      {{ t("pre.checkout.create.account") }}
    </div>
    <form class="pre-checkout-sidebar-register-form" accept-charset="utf-8" method="post">
      <div class="form-group">
        <label class="customer-register-form-label sr-only" for="sidebarRegisterMail">Email</label>
        <input id="sidebarRegisterMail"
          v-model="email"
          class="form-control"
          name="mail"
          placeholder="Το email σου"
          required
          type="email"
        >

      </div>
      <div class="form-group">
        <label class="customer-register-form-label sr-only" for="drowssap">Password</label>
        <input id="drowssap"
          ref="passwordInput"
          v-model="password"
          class="form-control password-class"
          name="drowssap"
          placeholder="Κωδικός"
          required
          type="password"
        >

      </div>
      <div class="form-group">
        <label class="customer-register-form-label sr-only" for="password_retype">Password</label>
        <input id="password_retype"
          ref="passwordRetypeInput"
          v-model="passwordRetype"
          class="form-control password-class"
          name="password_retype"
          placeholder="Επανάληψη κωδικού"
          required
          type="password"
        >
      </div>
      <button class="pre-checkout-sidebar-body-form-button submit-btn" name="register" type="submit" value="register">
        <span>
          {{  t("pre.checkout.sign.up.title") }}
        </span>
      </button>
    </form>
    <div class="pre-checkout-sidebar-register-actions">
      <div class="pre-checkout-sidebar-register-actions-return">
        <button class="pre-checkout-sidebar-register-actions-return-button"
          name="return"
          value="return"
          @click="onReturnBackClick"
        >
          <span class="pos-rel pre-checkout-sidebar-register-actions-return-button-text">
            {{  t("return") }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PreCheckoutSidebarRegister',
  data() {
    return {
      email: '',
      password: '',
      passwordRetype: '',
      passwordVisible: false,
      passwordRetypeVisible: false
    }
  },
  computed: {
    passwordImage() {
      return this.passwordVisible ? '/ui/main/img/eye_close.svg' : '/ui/main/img/eye_open.svg'
    },
    passwordRetypeImage() {
      return this.passwordRetypeVisible ? '/ui/main/img/eye_close.svg' : '/ui/main/img/eye_open.svg'
    }
  },
  methods: {
    onReturnBackClick() {
      this.$emit('return-back-click')
    }
  }
}
</script>

<style lang="scss" scoped>

.form-control {
  border: 1px solid #1A1818;
  border-radius: 0;
  padding: 0.938rem;
  color: #1A1818;
}

.pre-checkout-sidebar-body-form-button {
  background-color: #1A1818;
  font-size: 1.063rem; //17px
  border-radius: 0;
  width: 100%;
  font-weight: 700
}

.pre-checkout-sidebar-register-title {
  margin-bottom: 1.875rem;
}

.pre-checkout-sidebar-register-title-text {
  font-size: 24px;
  font-weight: 700;
  color: #231F20;
}

.pre-checkout-sidebar-register-actions {
  display: grid;
  gap: 100px;
  align-items: center;
  align-content: space-between;
  margin-top: 1.875rem
}

.pre-checkout-sidebar-register-actions-return {
  display: grid;
  gap: 14px;
}

</style>
